import { Column } from "react-table";

export default [
    {
        Header: 'Name',
        accessor: row => row.first_name + ' ' + row.last_name,
        width: "100%"
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
    {
        Header: 'Country',
        accessor: row => row.country.name
    },
    {
        Header: 'Title',
        accessor: 'title'
    }
] as Column<Interfaces.Jury.Includes<"country">>[]
